import { render, staticRenderFns } from "./MatchHistory.vue?vue&type=template&id=7ec6ad94"
import script from "./MatchHistory.vue?vue&type=script&lang=js"
export * from "./MatchHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports